import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M8.496 8.094c-.69.77-1.029 1.751-1.275 2.612l-.155.544H6.5c-.38 0-1.363.158-2.227.698-.824.515-1.523 1.357-1.523 2.802 0 1.211.548 1.92 1.267 2.36.762.468 1.738.64 2.483.64h11c.893 0 1.851-.226 2.564-.735.678-.485 1.186-1.258 1.186-2.515 0-1.795-.922-2.764-1.878-3.32a5.7 5.7 0 0 0-1.927-.68l-.026-.004h-.004l-.498-.056-.138-.484c-.218-.761-.647-1.555-1.38-2.158-.725-.595-1.8-1.048-3.399-1.048-1.803 0-2.844.608-3.504 1.344m9.577.997a5.7 5.7 0 0 0-1.722-2.452C15.326 5.797 13.901 5.25 12 5.25c-2.197 0-3.656.767-4.62 1.843-.772.86-1.187 1.874-1.451 2.702a6.4 6.4 0 0 0-2.452.882c-1.176.735-2.227 2.018-2.227 4.073 0 1.788.869 2.956 1.983 3.64 1.071.657 2.346.86 3.267.86h11c1.107 0 2.399-.274 3.436-1.015 1.072-.765 1.814-1.992 1.814-3.735 0-2.455-1.328-3.861-2.622-4.617a7.1 7.1 0 0 0-2.055-.792",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }